module.exports = __webpack_public_path__ + "img/ks.ed43e5f0.jpg";